import React from "react";

export function DealToggleRow({ isOn, title, hint, children, footer = null, className = "" }) {
  return (
    <div
      className={`deal-toggle-block${isOn ? " is-on" : ""}${className ? ` ${className}` : ""}`}
    >
      <div className="deal-toggle-row">
        <div className="deal-toggle-row__copy">
          <p className="deal-toggle-row__title">{title}</p>
          {hint ? <p className="deal-toggle-row__hint">{hint}</p> : null}
        </div>
        <div className="deal-toggle-row__control">{children}</div>
      </div>
      {footer ? <div className="deal-toggle-block__body">{footer}</div> : null}
    </div>
  );
}

export function DealSection({ icon, label, children, nested = false, headerRight = null }) {
  return (
    <section className={`deal-form-section${nested ? " deal-form-section--nested" : ""}`}>
      {label || headerRight ? (
        <div className={headerRight ? "deal-form-section__header" : undefined}>
          {label ? (
            <h2 className="deal-form-section__label">
              {icon ? (
                <span className="deal-form-section__label-icon" aria-hidden="true">
                  <i className={`fa ${icon}`} />
                </span>
              ) : null}
              {label}
            </h2>
          ) : (
            <span />
          )}
          {headerRight}
        </div>
      ) : null}
      {children}
    </section>
  );
}
